// ADMIN
export const ADD_DAYS_FORM = 'addDaysForm';
export const ADD_PRODUCT_ACCESS_FORM = 'addProductAccess';

export const CERTIFICATE = 'Certificate';
export const CERTIFICATE_FORM = 'certificateForm';

export const COUPON = 'Coupon';
export const COUPON_FORM = 'couponForm';

export const LICENSURE_FORM = 'licensureForm';

export const ORG_MEMBER_FORM = 'orgMemberForm';

export const TEST_ADMIN_OBJECT = 'Test';
export const TEST_ADMIN_FORM = 'testForm';

export const QUESTION_ADMIN_OBJECT = 'Question';
export const QUESTION_ADMIN_FORM = 'questionForm';

export const ANSWER_ADMIN_OBJECT = 'Answer';
export const ANSWER_ADMIN_FORM = 'answerForm';

export const SURVEY_ADMIN_OBJECT = 'Survey';
export const SURVEY_ADMIN_FORM = 'surveyForm';

export const PRODUCT_EVENT_ADMIN_OBJECT = 'Training Event';
export const PRODUCT_EVENT_ADMIN_FORM = 'trainingEventForm';

export const PRODUCT_REVIEW_ADMIN_OBJECT = 'Product Review';
export const PRODUCT_REVIEW_ADMIN_FORM = 'productReviewForm';

export const PRODUCT_DOWNLOAD_LINK_ADMIN_OBJECT = 'Download Link';
export const PRODUCT_DOWNLOAD_LINK_ADMIN_FORM = 'downloadLink';

export const PRODUCT_MEDIA_ADMIN_OBJECT = 'Attachment';
export const PRODUCT_MEDIA_ADMIN_FORM = 'productMediaForm';

export const LESSON_ADMIN_OBJECT = 'Lesson';
export const LESSON_ADMIN_FORM = 'lessonForm';

export const MY_PROFESSION_FORM = 'myProfessionForm';
export const MY_ORGANIZATION_FORM = 'myOrganizationForm';

export const CONSENT_FORM = 'consentForm';
export const EDUCATION_FORM = 'educationForm';
export const BOOK_VERIFICATION_FORM = 'bookVerificationForm';
export const SUICIDE_SPECIFIC_FORM = 'suicideSpecificFormik';

export const CHANGE_PASSWORD_FORM = 'changePasswordForm';

export const SURVEY_SECTION_ADMIN_OBJECT = 'Section';
export const SURVEY_SECTION_ADMIN_FORM = 'sectionForm';

export const DESIGNATION_ELEMENT_ADMIN_OBJECT = 'Designation Element';

export const PRODUCT_FAQ_ADMIN_OBJECT = 'Product Faq';
export const PRODUCT_FAQ_ADMIN_FORM = 'productFaqForm';

export const USER_OBJECT = 'User';
export const USER_FORM = 'userForm';

export const EDIT_LOCATOR_CONSENT = 'edit-locator-consent';

export const POPUP_CONFIRM_SUBMIT_DESIGNATION = 'popup-confirm-submit-designation';
export const POPUP_CONFIRM_CLEAR_CERTIFICATION = 'popup-confirm-clear-certification';

export const POPUP_ADD_CARD = 'popup-add-card';
export const POPUP_ADDRESS = 'popup-address';
export const POPUP_EDIT_CARD = 'popup-edit-card';
export const POPUP_VIEW_CARD = 'popup-view-card';

export const MODAL_LOGIN = 'modal-login';
export const POPUP_LOGIN = 'popup-login';
export const POPUP_REGISTER = 'popup-register';

export const INVITE_MANAGER_POPUP = 'invite-manager-popup';
export const CERTIFICATE_CAMS_POPUP = 'certificate-cams-popup';

export const TAKE_TEST_QUESTIONS = 'take-test-questions';
export const TAKE_TEST_RESULT = 'take-test-result';
export const TAKE_SURVEY_FORM = 'take-survey-form';
export const TAKE_SURVEY_RESULT = 'take-survey-result';
export const MODAL_JOIN_MEETING = 'modal-join-meeting';

export const POPUP_CHOOSE_TRAINING_EVENT_DATE = 'popup-choose-training-event-date';
export const POPUP_SELECT_EVENT = 'popup-select-event';
export const POPUP_CONTENT = 'popup-content';
export const POPUP_SELECT_CE = 'popup-select-ce';

export const TRACKING_NUMBER_TRACKING_CARRIER = 'trackingNumberTrackingCarrier';

export const TRAINING_GROUP_OBJECT = 'Training Group';
export const TRAINING_GROUP_FORM = 'trainingGroupForm';

export const VOUCHER_RULE = 'Voucher Rule';
export const VOUCHER_RULE_FORM = 'voucherRuleForm';
